export const getError = (state) => state.error;
export const getSuccess = (state) => state.success;
export const getIsLoading = (state) => state.isLoading;
export const getData = (state) => state.data;
export default {
    getError,
    getIsLoading,
    getSuccess,
    getData,
};
